import { graphql, compose } from 'react-apollo'
import { Row, Col } from 'reactstrap'
import BreadcrumbBar from '~/components/shared/BreadcrumbBar'
import { QueryAllTermOfServiceAppsInfo } from '~/queries/public.gql'
import { dataUnready } from '~/lib/helpers/dataUnready'
import ScpAppCard from '~/components/tos/ScpAppCard'

function TermsOfService ({ data }) {
  const { unready, cms_allTermOfServiceTopics: scpApps } = dataUnready(data, 'cms_allTermOfServiceTopics')
  let results = null
  const breadcrumbs = [
    { name: 'Terms of Service', href: '/tos' }
  ]

  if (unready) {
    results = unready
  } else {
    results = scpApps.map(app => <ScpAppCard key={app.id} app={app} />)
  }

  return (
    <>
      <BreadcrumbBar breadcrumbs={breadcrumbs} />
      <Row className='mb-md-2'>
        <Col>
          <h2>Terms of Service for SCP Health Applications</h2>
        </Col>
      </Row>
      <Row>
        {results}
      </Row>
    </>
  )
}

TermsOfService.publicAccess = true

TermsOfService.getInitialProps = () => ({
  title: 'Terms of Service'
})

const withAllTermOfServiceAppsInfo = graphql(QueryAllTermOfServiceAppsInfo)

export default compose(
  withAllTermOfServiceAppsInfo
)(TermsOfService)
